import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import store from '../../store';
import { CHANGE_PAGE_action } from '../../store/actions/pageAction';
import { CREATE_EVENT_action } from '../../store/actions/eventAction';

// Componentes de UI
import { Button, Card, Avatar, ToggleButtonGroup, ToggleButton, Chip, Menu, alpha, MenuItem, Grid, Paper, Box } from '@mui/material';
import banner from "../../images/banner.png"


// Iconos
import { CiMenuBurger, CiStar, CiUser } from "react-icons/ci";
import { GoSearch } from "react-icons/go";
import { DatePicker, LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';

import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Skeleton from '@mui/material/Skeleton';
import PublicIcon from '@mui/icons-material/Public';
import { useNavigate } from 'react-router-dom';
import SidebarResponsive from '../../components/SidebarResponsive';
import axios from 'axios';
import default_image from '../../images/default_image.svg'

// Iconos
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import HttpsIcon from '@mui/icons-material/Https';
import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';

// Otros iconos
import CampaignIcon from '@mui/icons-material/Campaign';
import CategoryIcon from '@mui/icons-material/Category'; // Icono para Tipo Evento "No definido"
import LiquorIcon from '@mui/icons-material/Liquor'; // Posible icono para Boliches
import CelebrationIcon from '@mui/icons-material/Celebration';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy'; // Icono para Tipo Evento "Teatro"
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports'; // Icono para Tipo Evento Viaje
import TravelExploreIcon from '@mui/icons-material/TravelExplore'; // Icono para Tipo Evento Nacional
import PetsIcon from '@mui/icons-material/Pets'; // Icono para Tipo Evento al Aire Libre
import PowerIcon from '@mui/icons-material/Power'; // Icono para Tipo Evento Virtual
import MusicNoteIcon from '@mui/icons-material/MusicNote'; // Icono para Tipo Evento Musical
import Diversity3Icon from '@mui/icons-material/Diversity3'; // Icono para Tipo Evento "Juntada"
import CakeIcon from '@mui/icons-material/Cake'; // Icono para Tipo Evento "Cumpleaños"
import WorkIcon from '@mui/icons-material/Work'; // Icono para Tipo Evento "Reunion Laboral"
import { GiDiamondRing } from "react-icons/gi"; // Icono para Tipo Evento "Casamiento"
import { EVENTDETAILS_action } from '../../store/actions/eventDetailsAction';
import CryptoJS from "crypto-js";

const mapStateToProps = (state) => {
    return {
        // page: state.pageReducer.pageName,
        token: state.tokenReducer.token,
        user: state.userReducer
    }
}

// COMPONENTES ESTILIZADOS
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        display: window.innerWidth >= 960 ? 'grid' : null,
        gridTemplateColumns: 'repeat(auto-fit, 400px)',
        justifyContent: 'center',
        columnGap: 16,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    }),
);

const Map = ({ location }) => {
    useEffect(() => {
        console.log("map location")
        console.log(location)
        let map;

        const initMap = async () => {
            const geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ location: location }, (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        console.log("Dirección encontrada:", results[0].formatted_address);
                    } else {
                        console.log("No se encontraron resultados.");
                    }
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });

            const position = { lat: location.lat, lng: location.lng };
            // const position = { lat: -32.4311892, lng: -63.72867609999999 };

            // Cargar bibliotecas de Google Maps
            const { Map } = await window.google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
            map = new Map(document.getElementById('map'), {
                zoom: 15,
                center: position,
                mapId: 'DEMO_MAP_ID',
            });

            new AdvancedMarkerElement({
                map: map,
                position: position,
                title: 'Uluru',
            });
        };

        initMap();
    }, []);

    return <div id="map" style={{ height: '100%', width: '100%', marginInline: 'auto' }}></div>;
};

// ELEMENTO ESTILIZADO
function MediaWeb(props) {
    const { user, event, onEventDeleted } = props;
    let userData = props.user
    const { loading = false } = props;
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [deletedEvent, setDeletedEvent] = useState(0)
    const [eventLocation, setEventLocation] = useState(props.event.eventLocation);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {

        if (props.event.eventLocationCoords) {
            const geocoder = new window.google.maps.Geocoder();
            const location = JSON.parse(props.event.eventLocationCoords);

            geocoder.geocode({ location }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setEventLocation(results[0].formatted_address);
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });
        }
    }, [props.event.eventLocationCoords]);

    const openEventDetails = () => {
        store.dispatch(EVENTDETAILS_action(props.event))
        // navigate("/eventdetails/" + props.event.eventID)
        navigate("/eventdetails")
        // return <Navigate to="/createevent" />;
    }

    const editEvent = () => {

        setAnchorEl(null)
        // navigate("/editevent/" + props.event.EventID, {eventData: props.event})
        navigate("/editevent", { eventData: props.event })
        store.dispatch(EVENTDETAILS_action(props.event))


    }

    const deleteEvent = () => {
        const token = localStorage.getItem('jwt_token');
        setAnchorEl(null)
        const headers = 'content-type: application/json; charset=utf-8'
        const data = { data: props.event.eventID }


        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        axios.post('https://socializeapi.azurewebsites.net/api/DeleteEvent', { data: data_encripted }, {
            headers
        })
            .then(response => {
                // Creados(userData)
                // getEvents()
                onEventDeleted();

            })
            .catch(error => {
                console.log(`Error al intentar eliminar el evento: ${error}`);
            });
    }


    const getEvents = () => {

        const headers = 'content-type: application/json; charset=utf-8'
        axios.get(`https://socializeapi.azurewebsites.net/api/GetEvents?creatorID=${props.user.id}`, { headers })
            .then(response => {
            })
            .catch(error => {
                console.log(`Error obteniendo datos: ${error}`);
            })
    }

    const handleShare = async (e) => {

        console.log(e)


        const encryptedID = CryptoJS.AES.encrypt(e.toString(), "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Invitación',
                    text: 'Únete al evento en nuestra página',
                    url: `https://hisocialize.netlify.app/registro?data=${encodeURIComponent(encryptedID)}`,
                });
                console.log('Compartido con éxito');
            } catch (error) {
                console.error('Error al compartir:', error);
            }
        } else {
            alert('La función de compartir no está disponible en este dispositivo.');
        }
    };

    return (
        <Card
            elevation={isHovered ? 4 : 1}
            sx={{
                maxWidth: 400,
                mb: 4,
                borderRadius: 4,
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-4px)'
                }
            }}
            onClick={openEventDetails}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {props.event.eventImage ? (
                <>
                    <CardMedia
                        component="img"
                        height="200"
                        image={`${props.event.eventImage}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                        sx={{ borderRadius: '16px 16px 0 0' }}
                    />

                    <IconButton
                        style={{
                            backgroundColor: '#2196f3',
                            color: 'white',
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            zIndex: 1,
                            // Agrega estilos adicionales según sea necesario
                        }}
                        onClick={(event) => { setAnchorEl(event.currentTarget); event.stopPropagation(); }}
                    >
                        <MoreVertIcon></MoreVertIcon>
                    </IconButton>

                    <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={(e) => { setAnchorEl(null); e.stopPropagation(); }}
                    >
                        {props.event.eventPrivacity == 'PRIVADO' && (

                            <MenuItem onClick={(e) => { handleShare(props.event.eventID); e.stopPropagation(); }} disableRipple>
                                {/* <EditIcon /> */}
                                Invitar amigos
                            </MenuItem>
                        )}

                        <MenuItem onClick={(e) => { editEvent(); e.stopPropagation(); }} disableRipple>
                            {/* <EditIcon /> */}
                            Editar
                        </MenuItem>
                        {/* <Divider sx={{ my: 0.5 }} /> */}
                        <MenuItem onClick={(e) => { deleteEvent(); e.stopPropagation(); }} disableRipple>
                            {/* <FileCopyIcon /> */}
                            Eliminar
                        </MenuItem>
                    </StyledMenu>
                </>


            ) : (
                <Box
                    sx={{
                        height: 200,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: 'grey.100',
                        borderRadius: '16px 16px 0 0'
                    }}
                >
                    <IconButton
                        style={{
                            backgroundColor: '#2196f3',
                            color: 'white',
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            zIndex: 1,
                            // Agrega estilos adicionales según sea necesario
                        }}
                        onClick={(event) => { setAnchorEl(event.currentTarget); event.stopPropagation(); }}
                    >
                        <MoreVertIcon></MoreVertIcon>
                    </IconButton>

                    <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={(e) => { setAnchorEl(null); e.stopPropagation(); }}
                    >
                        {props.event.eventPrivacity == 'PRIVADO' && (

                            <MenuItem onClick={(e) => { handleShare(props.event.eventID); e.stopPropagation(); }} disableRipple>
                                {/* <EditIcon /> */}
                                Invitar amigos
                            </MenuItem>
                        )}

                        <MenuItem onClick={(e) => { editEvent(); e.stopPropagation(); }} disableRipple>
                            {/* <EditIcon /> */}
                            Editar
                        </MenuItem>
                        {/* <Divider sx={{ my: 0.5 }} /> */}
                        <MenuItem onClick={(e) => { deleteEvent(); e.stopPropagation(); }} disableRipple>
                            {/* <FileCopyIcon /> */}
                            Eliminar
                        </MenuItem>
                    </StyledMenu>
                    <Avatar
                        src={`${props.event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                        sx={{
                            width: 120,
                            height: 120,
                            mb: 2
                        }}
                    />
                    <Typography variant="subtitle1" fontWeight="medium" color="text.secondary">
                        {props.event.creatorName}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        Creador del evento
                    </Typography>
                </Box>
            )}

            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: 'medium' }} fontFamily={'Trebuchet MS'}>
                                {props.event.eventTitle}
                            </Typography>
                            <Chip
                                label={props.event.eventPrivacity === "PUBLICO" ? "Público" : "Privado"}
                                color={props.event.eventPrivacity === "PUBLICO" ? "primary" : "warning"}
                                size="small"
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }}>
                                        <PersonIcon />
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>{props.event.creatorName}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }}>
                                        <CalendarMonthOutlinedIcon />
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>
                                        {(new Date(props.event.startDay)).toLocaleDateString("es-ES")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" fontFamily={'Fredoka, sans-serif'}>
                                        {props.event.startHour}
                                        {props.event.startHour.split(":")[0] >= 12 ? ' PM' : ' AM'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: isHovered ? 'primary.light' : 'grey.50',
                                borderRadius: 2,
                                transition: 'background 0.3s ease'
                            }}
                        >
                            <Grid container spacing={2} alignItems="center">
                                <Grid item>
                                    <Avatar sx={{ bgcolor: isHovered ? 'primary.dark' : 'primary.main' }}>
                                        <LocationOnIcon />
                                    </Avatar>
                                </Grid>
                                <Grid item xs>
                                    <Typography fontFamily={'Fredoka, sans-serif'}>
                                        {props.event.eventLocation || "Ubicación no especificada"}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

// ELEMENTO ESTILIZADO
function MediaMobile(props) {
    const { user, event, onEventDeleted } = props;
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    // Estado para alternar la altura
    const [isHeightIncreased, setIsHeightIncreased] = React.useState(true);
    const [eventLocation, setEventLocation] = useState(props.event.eventLocation);

    let [showCalendar, setShowCalendar] = useState(false);
    let [showMiniMap, setShowMiniMap] = useState(false);
    let [traducedDay, setTraducedDay] = useState('');
    let [traducedMonth, setTraducedMonth] = useState('');

    const traducirDia = (dia) => {
        switch (dia.split("-")[1]) {
            case '01':
                setTraducedMonth("Enero");
                break;
            case '02':
                setTraducedMonth("Febrero");
                break;
            case '03':
                setTraducedMonth("Marzo");
                break;
            case '04':
                setTraducedMonth("Abril");
                break;
            case '05':
                setTraducedMonth("Mayo");
                break;
            case '06':
                setTraducedMonth("Junio");
                break;
            case '07':
                setTraducedMonth("Julio");
                break;
            case '08':
                setTraducedMonth("Agosto");
                break;
            case '09':
                setTraducedMonth("Sept");
                break;
            case '10':
                setTraducedMonth("Octubre");
                break;
            case '11':
                setTraducedMonth("Noviembre");
                break;
            case '12':
                setTraducedMonth("Diciembre");
                break;
            default:
                break;
        }

        var hora = dia.split("-")[2]

        setTraducedDay(hora.split("T")[0])

    }

    const openEventDetails = () => {
        store.dispatch(EVENTDETAILS_action(props.event))
        // navigate("/eventdetails/" + props.event.eventID)
        navigate("/eventdetails")
        // return <Navigate to="/createevent" />;
    }

    const editEvent = () => {

        setAnchorEl(null)
        // navigate("/editevent/" + props.event.EventID, {eventData: props.event})
        navigate("/editevent", { eventData: props.event })
        store.dispatch(EVENTDETAILS_action(props.event))


    }

    const deleteEvent = () => {
        const token = localStorage.getItem('jwt_token');
        setAnchorEl(null)
        const headers = 'content-type: application/json; charset=utf-8'
        const data = { data: props.event.eventID }


        const jsonData = JSON.stringify(data);
        const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

        axios.post('https://socializeapi.azurewebsites.net/api/DeleteEvent', { data: data_encripted }, {
            headers
        })
            .then(response => {
                // Creados(userData)
                // getEvents()
                onEventDeleted();

            })
            .catch(error => {
                console.log(`Error al intentar eliminar el evento: ${error}`);
            });
    }


    const handleShare = async (e) => {

        console.log(e)


        const encryptedID = CryptoJS.AES.encrypt(e.toString(), "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();
        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'Invitación',
                    text: 'Únete al evento en nuestra página',
                    url: `https://hisocialize.netlify.app/registro?data=${encodeURIComponent(encryptedID)}`,
                });
                console.log('Compartido con éxito');
            } catch (error) {
                console.error('Error al compartir:', error);
            }
        } else {
            alert('La función de compartir no está disponible en este dispositivo.');
        }
    };

    // Función para aumentar la altura del `Media`
    const toggleHeight = () => {
        // setHeight((prevHeight) => prevHeight + 50); // Incrementa la altura en 50px
        setIsHeightIncreased((prev) => !prev);
    };

    useEffect(() => {
        if (props.event.eventLocationCoords) {
            const geocoder = new window.google.maps.Geocoder();
            const location = JSON.parse(props.event.eventLocationCoords);

            geocoder.geocode({ location }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setEventLocation(results[0].formatted_address);
                } else {
                    console.error("Fallo en la geocodificación inversa: " + status);
                }
            });
        }
    }, [props.event.eventLocationCoords]);

    return (
        <Card
            elevation={0}
            sx={{
                maxWidth: 460,
                m: 2,
                borderRadius: 3,
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6
                },
                marginInline: !props.isLargeScreen && 'auto',
                overflow: 'hidden'
            }}
            onClick={openEventDetails}
        >
            {showMiniMap ? (
                <CardContent sx={{ p: 0, position: 'relative', height: 220 }}>
                    <div style={{ height: '100%' }} onClick={(e) => e.stopPropagation()}>
                        <Map location={JSON.parse(props.event.eventLocationCoords)} />
                        <IconButton
                            sx={{
                                position: 'absolute',
                                bottom: 20,
                                left: '50%',
                                transform: 'translateX(-50%)',
                                bgcolor: 'rgba(63, 81, 181, 0.8)',
                                '&:hover': {
                                    bgcolor: 'rgba(63, 81, 181, 0.9)'
                                }
                            }}
                            onClick={() => setShowMiniMap(false)}
                        >
                            <KeyboardBackspaceRoundedIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </div>
                </CardContent>
            ) : (
                <CardContent sx={{ p: 2, position: 'relative' }}>
                    <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}>
                        <IconButton
                            sx={{
                                backgroundColor: '#2196f3',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#1976d2'
                                }
                            }}
                            onClick={(event) => { setAnchorEl(event.currentTarget); event.stopPropagation(); }}
                        >
                            <MoreVertIcon />
                        </IconButton>
                    </Box>

                    <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={(e) => { setAnchorEl(null); e.stopPropagation(); }}
                    >
                        {props.event.eventPrivacity == 'PRIVADO' && (
                            <MenuItem onClick={(e) => { handleShare(props.event.eventID); e.stopPropagation(); }} disableRipple>
                                Invitar amigos
                            </MenuItem>
                        )}

                        <MenuItem onClick={(e) => { editEvent(); e.stopPropagation(); }} disableRipple>
                            Editar
                        </MenuItem>
                        <MenuItem onClick={(e) => { deleteEvent(); e.stopPropagation(); }} disableRipple>
                            Eliminar
                        </MenuItem>
                    </StyledMenu>
                    
                    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar
                            src={`${props.event.creatorAvatar}?sp=racwdli&st=2025-03-10T21:49:45Z&se=2026-08-06T05:49:45Z&spr=https&sv=2022-11-02&sr=c&sig=GcXlifAeQNMN09HG4bkOXCZGmZSNVlc55Aa075L2l5Q%3D`}
                            sx={{ width: 48, height: 48 }}
                        />
                        <Box sx={{ flex: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontFamily: 'Trebuchet MS',
                                        fontWeight: 600,
                                        fontSize: '1.1rem'
                                    }}
                                >
                                    {props.event.eventTitle}
                                </Typography>
                                {props.event.eventPrivacity === "PRIVADO" && (
                                    <Chip
                                        label="Privado"
                                        size="small"
                                        sx={{
                                            bgcolor: '#ffa726',
                                            color: 'white',
                                            height: 24
                                        }}
                                    />
                                )}
                            </Box>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary',
                                    fontFamily: 'Fredoka, sans-serif'
                                }}
                            >
                                {props.event.creatorName}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Paper
                            elevation={0}
                            sx={{
                                flex: 1,
                                bgcolor: 'rgba(0, 150, 136, 0.9)',
                                borderRadius: 2,
                                p: 2,
                                position: 'relative',
                                overflow: 'hidden',
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setShowCalendar(!showCalendar);
                                traducirDia(props.event.startDay);
                            }}
                        >
                            <CalendarMonthOutlinedIcon
                                sx={{
                                    position: 'absolute',
                                    fontSize: 100,
                                    opacity: 0.2,
                                    right: -20,
                                    bottom: -20
                                }}
                            />
                            <Box sx={{ position: 'relative', zIndex: 1 }}>
                                <Typography sx={{ color: 'white', mb: 1 }}>
                                    {(new Date(props.event.startDay)).toLocaleDateString("es-ES")}
                                </Typography>
                                <Typography sx={{ color: 'white' }}>
                                    {props.event.startHour}
                                    {props.event.startHour.split(":")[0] >= 12 ? ' PM' : ' AM'}
                                </Typography>
                            </Box>
                        </Paper>

                        <Paper
                            elevation={0}
                            sx={{
                                flex: 1,
                                bgcolor: props.event.eventLocation ? 'rgba(63, 81, 181, 0.9)' : '#f1f2f6',
                                borderRadius: 2,
                                p: 2,
                                position: 'relative',
                                overflow: 'hidden',
                                cursor: props.event.eventLocation ? 'pointer' : 'default'
                            }}
                            onClick={(e) => {
                                if (props.event.eventLocation) {
                                    e.stopPropagation();
                                    setShowMiniMap(true);
                                }
                            }}
                        >
                            <LocationOnIcon
                                sx={{
                                    position: 'absolute',
                                    fontSize: 100,
                                    opacity: 0.2,
                                    right: -20,
                                    bottom: -20
                                }}
                            />
                            <Typography
                                sx={{
                                    color: props.event.eventLocation ? 'white' : 'text.primary',
                                    position: 'relative',
                                    zIndex: 1,
                                    fontSize: props.event.eventLocation ? '0.875rem' : '0.75rem',
                                    textAlign: 'left'
                                }}
                            >
                                {props.event.eventLocation || "Ubicación no especificada"}
                            </Typography>
                        </Paper>
                    </Box>
                </CardContent>
            )}
        </Card>

    );


}

MediaWeb.propTypes = {
    loading: PropTypes.bool,
};



const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));


// MAIN
const Creados = ({ user }) => {
    const [isLargeScreen, setIsLargeScreen] = useState(null); // Mide el tamaño de la pantalla para hacer el diseño responsive
    const navigate = useNavigate()
    let [loadingPage, setLoadingPage] = useState(true)

    const [events, setEvents] = useState([])
    const DeleteEvent = () => {

    }


    let data = {
        title: "",
        eventPrivacity: "",
        userID: "",
        creatorID: user.id
    }

    const jsonData = JSON.stringify(data);
    const data_encripted = CryptoJS.AES.encrypt(jsonData, "EsteEsUnEjemploDeClaveDe32Caracteres!").toString();

    const token = localStorage.getItem('jwt_token');

    function decryptData(encryptedText) {
        // Define la misma clave que usaste en el backend
        const key = "AKeyThatIsAtLeast32CharactersLongForHS256";

        // Decodifica el texto encriptado de base64
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Extrae el IV (los primeros 16 bytes) y el contenido encriptado
        const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4), 16);
        const encryptedContent = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));

        // Deriva la clave usando SHA256
        const hashedKey = CryptoJS.SHA256(key);

        // Desencripta el contenido
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedContent },
            hashedKey,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convierte el resultado a texto legible
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    const fetchEvents = () => {
        let data = {
            title: "",
            // creatorName: props.user.nombre,
            eventPrivacity: "",
            // creatorID: contenedorSEC,
            userID: (user.id) ? user.id : 0,
            creatorID: 0
        }

        setLoadingPage(true)
        const headers = 'content-type: application/json; charset=utf-8'
        axios.post(`https://socializeapi.azurewebsites.net/api/GetEvents`, data, {
            headers
        })
            .then(response => {
                // let decripted_response = decryptData(response.data)
                // let convertedToArray = JSON.parse(decripted_response)
                // console.log("Eventos obtenidos:", convertedToArray);
                const mainEvents = response.data.filter(item => JSON.parse(localStorage.getItem('userData')).userID == item.creatorId);
                console.log(mainEvents)

                const sortedCombinedEvents = mainEvents.sort((a, b) => {
                    // Crear objetos Date combinando eventDate y startHour
                    const dateA = new Date(`${a.startDay.split("T")[0]}T${a.startHour}`);
                    const dateB = new Date(`${b.startDay.split("T")[0]}T${b.startHour}`);

                    // Comparar las fechas y horas combinadas
                    return dateA - dateB;
                });


                setEvents(sortedCombinedEvents);

                setLoadingPage(false)
            })
            .catch(error => {
                console.log(`Error obteniendo eventos: ${error}`);
            });
    };



    useEffect(() => {
        if (!token) {
            console.log("el token no es valido")
            navigate("/")
        } else {
            fetchEvents()
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 960); // set the breakpoint here
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div>
            <Header></Header>
            <div style={{
                display: 'flex',
                width: '100%',
            }}>
                {isLargeScreen ? (<Sidebar></Sidebar>) : (<SidebarResponsive></SidebarResponsive>)}
                <div style={{ marginTop: 80, width: '100%' }}>
                    <Main>
                        {loadingPage ? (
                            <>
                                {isLargeScreen ? (
                                    <div className="skeleton-card">
                                        <div style={{ height: 200 }}></div>
                                        <div className="skeleton-text skeleton-title"></div>
                                        <div className="skeleton-text skeleton-subtitle"></div>
                                        <div className="skeleton-text skeleton-date"></div>
                                        <div className="skeleton-text skeleton-location"></div>
                                    </div>
                                ) : (
                                    <div className="skeleton-card-responsive">
                                        <div className="skeleton-text-responsive skeleton-title-responsive"></div>
                                        <div className="skeleton-text-responsive skeleton-subtitle-responsive"></div>
                                    </div>
                                )}


                            </>
                        ) : (
                            events.length === 0 ? (
                                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Typography>No hay eventos para mostrarte</Typography>
                                    <Typography>Crea un evento de manera rápida y sencilla!</Typography>
                                </div>
                            ) : (
                                isLargeScreen ? (
                                    events.map((item, index) => (
                                        <MediaWeb key={index}
                                            event={item}
                                            user={user}
                                            onEventDeleted={fetchEvents}
                                            isLargeScreen={isLargeScreen}
                                        />
                                    ))

                                ) : (
                                    events.map((item, index) => (
                                        <MediaMobile key={index}
                                            event={item}
                                            user={user}
                                            onEventDeleted={fetchEvents}
                                            isLargeScreen={isLargeScreen}
                                        />
                                    ))
                                )
                            )
                        )}
                    </Main>
                </div>
            </div>
        </div>
    )

}

export default connect(mapStateToProps)(Creados);